import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const batteryService = {
  getAvailable: async (params) => {
    const response = await authInstance
      .get(`${url}/battery/getAvailable?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
